import { CSSProperties, ReactNode } from "react";

// MUI
import { Grid, Paper, Typography } from "@mui/material";

// Images
import whiteLogo from "@/assets/images/login/dat_logo_white.svg";

import "./styles.css";

interface DASBoxProps {
	children: ReactNode;
	title: ReactNode;
	content: ReactNode;
	author?: string;
	textSx?: CSSProperties;
}

export default function DASBox(props: Readonly<DASBoxProps>) {
	return (
		<Paper className="das-container" elevation={0} sx={{ backgroundColor: "transparent" }}>
			<Grid container>
				<Grid item sm={8} p={2} className="section-login-container box-regular-shadow">
					{props.children}
				</Grid>
				<Grid
					container
					item
					position="relative"
					direction="column"
					justifyContent="space-between"
					alignItems="center"
					sm={4}
					className="custom-right-gradient right-borders vertical-center box-regular-shadow mH300"
				>
					<Grid item container px={4} py={5} justifyContent={"center"} alignContent={"center"} sx={{ minHeight: 150 }}>
						<Grid item sx={props.textSx}>
							<Typography className="big-title text-white" variant="h5" component="div" gutterBottom>
								{props.title}
							</Typography>
							<Typography className="regular-description" variant="body2" gutterBottom>
								{props.content}
							</Typography>
							<Typography
								className="regular-description"
								variant="body2"
								gutterBottom
								sx={{
									fontStyle: "italic",
									textAlign: "right",
									fontSize: "13px !important",
									marginRight: "15px",
								}}
							>
								{props.author ?? ""}
							</Typography>
						</Grid>
					</Grid>

					<Grid item container px={4} py={5} justifyContent={"center"} alignContent={"center"}>
						<img src={whiteLogo} className="das-img img-fluid" alt="DAS" />
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
}
